export default "__VITE_ASSET__AYUNMXFN__"